/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 * @example
 * // Usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *
 * // Output
 * element {
 *   background: "rgba(255,255,255,0.9)";
 * }
 */
export const transparentize = (amount, color) => {
    if (color[0] === '#') {
        const rgb = [];
        if (color.length === 4) {
            rgb.push(convertHexToDec(color.substring(1, 2)));
            rgb.push(convertHexToDec(color.substring(2, 3)));
            rgb.push(convertHexToDec(color.substring(3)));
        }
        if (color.length === 7) {
            rgb.push(convertHexToDec(color.substring(1, 3)));
            rgb.push(convertHexToDec(color.substring(3, 5)));
            rgb.push(convertHexToDec(color.substring(5)));
        }
        if (color === 'transparent')
            return color;
        const alpha = (1 - amount).toFixed(2);
        return `rgba(${rgb.join(',')},${alpha})`;
    }
    return color;
};
const convertHexToDec = (hex) => parseInt(`0x${hex}`);
//# sourceMappingURL=mixins.js.map